export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'Bem-vindo ao MyStorageX',
  'login.description': 'MyStorageX é seu assistente de armazenamento em nuvem, oferecendo armazenamento e gerenciamento de arquivos seguro e conveniente. Acesse seus arquivos a qualquer hora e em qualquer lugar.',
  'login.email.placeholder': 'Email ou nome de usuário',
  'login.password.placeholder': 'Senha',
  'login.button': 'Entrar',
  'login.loading': 'Entrando...',
  'login.divider': 'ou',
  'login.signup': 'Não tem uma conta?',
  'login.signup.link': 'Registre-se',
  'login.error.default': 'Falha no login, tente novamente mais tarde',
  'login.success': 'Login realizado',
  'login.forgotPassword': 'Esqueceu a senha?',
  'login.forgotPassword.link': 'Redefinir aqui',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'Bem-vindo ao MyStorageX',
  'signup.description': 'Crie sua conta e comece sua jornada de armazenamento em nuvem',
  'signup.username.placeholder': 'Digite o nome de usuário',
  'signup.email.placeholder': 'Digite o email',
  'signup.password.placeholder': 'Digite a senha',
  'signup.confirmPassword.placeholder': 'Confirme a senha',
  'signup.button': 'Registrar',
  'signup.loading': 'Registrando...',
  'signup.login': 'Já tem uma conta?',
  'signup.login.link': 'Entrar',
  'signup.error.passwordMismatch': 'As senhas não correspondem',
  'signup.error.default': 'Falha no registro, tente novamente mais tarde',
  'signup.success': 'Registro concluído',
  'signup.username.rule.length': 'O nome de usuário deve ter entre 4 e 10 caracteres',
  'signup.username.rule.format': 'Apenas letras, números, sublinhados e hífens são permitidos',
  'signup.password.rule.length': 'A senha deve ter entre 6 e 20 caracteres',
  'signup.password.rule.lowercase': 'Deve conter letras minúsculas',
  'signup.password.rule.uppercase': 'Deve conter letras maiúsculas',
  'signup.password.rule.number': 'Deve conter números',
  'signup.password.rule.special': 'Deve conter caracteres especiais',
  'resetPassword.page.title': 'Redefinir senha - MyStorageX',
  'resetPassword.page.description': 'Redefina a senha da sua conta MyStorageX',
  'resetPassword.title': 'Redefinir senha',
  'resetPassword.email.placeholder': 'Digite seu endereço de email',
  'resetPassword.code.placeholder': 'Digite o código de verificação',
  'resetPassword.password.placeholder': 'Digite a nova senha',
  'resetPassword.button': 'Redefinir',
  'resetPassword.button.loading': 'Redefinindo...',
  'resetPassword.backToLogin': 'Voltar ao login',
  'resetPassword.sendCode': 'Obter código',
  'resetPassword.sendCode.sending': 'Enviando...',
  'resetPassword.sendCode.retry': 'Tentar novamente em {seconds}s',
  'resetPassword.error.emailRequired': 'Por favor, digite seu endereço de email',
  'resetPassword.error.codeRequired': 'Por favor, digite o código de verificação',
  'resetPassword.error.passwordRequired': 'Por favor, digite a nova senha',
  'resetPassword.error.passwordLength': 'A senha deve ter entre 6 e 20 caracteres',
  'resetPassword.error.codeLength': 'O código de verificação deve ter 6 dígitos',
  'resetPassword.success.codeSent': 'O código de verificação foi enviado para seu email',
  'resetPassword.success.reset': 'Senha redefinida com sucesso',
  'resetPassword.error.sendFailed': 'Falha ao enviar o código de verificação, tente novamente mais tarde',
  'resetPassword.error.resetFailed': 'Falha ao redefinir a senha, tente novamente mais tarde',
  'signup.verificationCode.placeholder': 'Digite o código de verificação',
  'signup.verificationCode.send': 'Obter código',
  'signup.verificationCode.sending': 'Enviando...',
  'signup.verificationCode.retry': 'Tentar novamente em {seconds}s',
  'signup.verificationCode.success': 'Código de verificação enviado',
  'signup.verificationCode.error': 'Falha ao enviar o código',
  'signup.verificationCode.required': 'Por favor, digite o código de verificação',
  'signup.verificationCode.invalid': 'Formato de código de verificação inválido',
  'signup.error.emailRequired': 'Por favor, digite seu endereço de email',
  'signup.announcement': 'A função de registro está em manutenção hoje!',
  'sidebar.allFiles': 'Todos os arquivos',
  'sidebar.starred': 'Favoritos',
  'sidebar.folders': 'Pastas',
  'sidebar.trash': 'Lixeira',
  'sidebar.decrypt': 'Ferramenta de descriptografia',
  'sidebar.feedback': 'Feedback',
  'sidebar.about': 'Sobre',
  'sidebar.productLog': 'Atualizações',
  'filelist.column.name': 'Nome',
  'filelist.column.size': 'Tamanho',
  'filelist.column.updateTime': 'Modificado',
  'filelist.column.recycletime': 'Data de exclusão',
  'filelist.column.actions': 'Ações',
  'filelist.total': 'Total de {total} itens',
  'filelist.action.upload': 'Enviar',
  'filelist.action.newFolder': 'Nova pasta',
  'filelist.action.refresh': 'Atualizar',
  'filelist.action.search': 'Buscar arquivos',
  'filelist.action.batchDownload': 'Baixar',
  'filelist.action.batchDelete': 'Excluir',
  'filelist.selected': '{count} selecionados',
  'page.cloudDrive.title': 'Meu Cloud Drive',
  'page.cloudDrive.description': 'MyStorageX Cloud Drive - Armazene e gerencie seus arquivos com segurança',
  'modal.fileUpload.title': 'Enviar arquivos',
  'modal.fileUpload.dragText': 'Arraste arquivos aqui ou clique para enviar',
  'modal.fileUpload.start': 'Iniciar envio',
  'modal.fileUpload.cancel': 'Cancelar',
  'modal.fileUpload.clear': 'Limpar lista',
  'modal.fileUpload.encrypt': 'Criptografar selecionados',
  'modal.fileUpload.addMore': 'Adicionar',
  'modal.fileUpload.remove': 'Remover',
  'modal.fileUpload.error.noSelection': 'Selecione arquivos para remover',
  'modal.fileUpload.error.noEncryption': 'Selecione arquivos para criptografar',
  'modal.fileUpload.error.noClear': 'Não há arquivos para limpar',
  'modal.fileUpload.error.noStart': 'Não há arquivos para enviar',
  'modal.fileUpload.error.noCancel': 'Não há envios ativos para cancelar',
  'modal.fileUpload.error.fileSize': 'Tamanho do arquivo excedido',
  'modal.fileUpload.error.fileType': 'Tipo de arquivo não suportado',
  'modal.fileUpload.error.maxCount': 'Número máximo de arquivos excedido',
  'modal.fileUpload.duplicate.title': 'Arquivo já existe',
  'modal.fileUpload.duplicate.skip': 'Pular',
  'modal.fileUpload.duplicate.replace': 'Substituir',
  'modal.fileUpload.duplicate.rename': 'Renomear',
  'modal.fileUpload.status.pending': 'Pendente',
  'modal.fileUpload.status.uploading': 'Enviando',
  'modal.fileUpload.status.success': 'Concluído',
  'modal.fileUpload.status.error': 'Erro',
  'modal.fileUpload.status.cancelled': 'Cancelado',
  'modal.fileUpload.status.duplicated': 'Duplicado',
  'modal.fileUpload.table.filename': 'Nome do arquivo',
  'modal.fileUpload.table.size': 'Tamanho',
  'modal.fileUpload.table.status': 'Status',
  'modal.fileUpload.table.progress': 'Progresso',
  'modal.fileUpload.table.actions': 'Ações',
  'modal.fileUpload.speed': 'Velocidade de envio',
  'modal.fileUpload.remainingTime': 'Tempo restante',
  'modal.fileUpload.total.progress': 'Progresso total',
  'modal.fileUpload.error.message': 'Erro no envio: {message}',
  'modal.fileUpload.confirm.clear': 'Deseja limpar a lista de envio?',
  'modal.fileUpload.confirm.cancel': 'Deseja cancelar o envio?',
  'modal.fileUpload.clear.mobile': 'Limpar',
  'modal.fileUpload.encrypt.mobile': 'Criptografar',
  'modal.fileUpload.addMore.mobile': 'Adicionar',
  'modal.newFolder.title': 'Nova pasta',
  'modal.newFolder.placeholder': 'Digite o nome da pasta',
  'modal.newFolder.ok': 'Criar',
  'modal.newFolder.cancel': 'Cancelar',
  'productLog.title': 'Atualizações do produto',
  'page.decrypt.title': 'Ferramenta de descriptografia de arquivos MyStorage',
  'page.decrypt.subtitle': 'Descriptografe seus arquivos com segurança',
  'page.decrypt.helmet.title': 'Ferramenta de descriptografia - MyStorage',
  'page.decrypt.helmet.description': 'Ferramenta segura de descriptografia - Descriptografe seus arquivos localmente no navegador para proteger sua privacidade',
  'decrypt.upload.dragText': 'Clique ou arraste arquivos',
  'decrypt.upload.hint': 'Suporta arquivos .encrypted, máximo {maxSize} por arquivo',
  'decrypt.upload.button.decrypt': 'Descriptografar selecionados',
  'decrypt.upload.button.clear': 'Limpar lista',
  'decrypt.fileList.empty': 'Não há arquivos, adicione arquivos para descriptografar',
  'decrypt.fileList.column.name': 'Nome do arquivo',
  'decrypt.fileList.column.size': 'Tamanho',
  'decrypt.fileList.column.status': 'Status',
  'decrypt.fileList.column.actions': 'Ações',
  'decrypt.fileList.status.pending': 'Pendente',
  'decrypt.fileList.status.decrypting': 'Descriptografando',
  'decrypt.fileList.status.success': 'Concluído',
  'decrypt.fileList.status.error': 'Erro',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.password.modal.title': 'Digite a senha de descriptografia',
  'decrypt.password.modal.placeholder': 'Digite a senha',
  'decrypt.password.modal.hint': 'Digite a senha definida durante a criptografia, ela será usada apenas para descriptografia local',
  'decrypt.security.modal.title': 'Aviso de segurança',
  'decrypt.security.modal.description': 'Todas as operações de descriptografia são realizadas localmente, sua senha e o conteúdo do arquivo nunca serão enviados ao servidor',
  'signup.page.title': 'Registro - MyStorageX',
  // Recursos de segurança
  'security.features.title': 'Recursos de segurança',
  'security.features.localDecryption.title': 'Proteção de descriptografia local',
  'security.features.localDecryption.description': 'Todas as operações de descriptografia são realizadas localmente em seu navegador, garantindo que o conteúdo de seus arquivos e senhas nunca sejam carregados nos servidores',
  'security.features.militaryEncryption.title': 'Criptografia de nível militar',
  'security.features.militaryEncryption.description': 'Utiliza o algoritmo de criptografia AES-256-CBC, o padrão de criptografia simétrica mais seguro disponível que pode resistir a todos os métodos de ataque conhecidos',
  'security.features.privacyProtection.title': 'Proteção de dados privados',
  'security.features.privacyProtection.description': 'Mecanismos rigorosos de proteção de privacidade garantem que nenhuma senha de descriptografia seja armazenada e nenhum conteúdo de arquivo seja registrado',
  'security.features.smartDecryption.title': 'Descriptografia inteligente em blocos',
  'security.features.smartDecryption.description': 'Utiliza tecnologia de descriptografia inteligente em blocos para melhorar significativamente a velocidade de descriptografia enquanto reduz consideravelmente o uso de memória',
  'security.features.learnMore': 'Saiba mais',
  'security.features.modal.title': 'Detalhes dos recursos de segurança',
  'security.features.modal.close': 'Fechar',
  // Modal de dicas de segurança
  'decrypt.security.modal.vip.title': 'Caro usuário VIP, você pode:',
  'decrypt.security.modal.vip.feature1': 'Descriptografar arquivos de qualquer tamanho',
  'decrypt.security.modal.vip.feature2': 'Usar descriptografia inteligente em blocos para maior eficiência e menor uso de memória',
  'decrypt.security.modal.vip.feature3': 'Suportar descriptografia em lote de múltiplos arquivos grandes',
  'decrypt.security.modal.free.title': 'Importante: O processo de descriptografia requer memória do navegador, o uso real de memória é aproximadamente 3 vezes o tamanho do arquivo.',
  'decrypt.security.modal.free.feature1': 'Usuários não VIP estão limitados a 4GB por arquivo',
  'decrypt.security.modal.free.feature2': 'Faça upgrade para VIP para descriptografar arquivos de qualquer tamanho e habilitar a descriptografia em blocos',
  'decrypt.security.modal.free.feature3': 'Se o navegador travar, faça upgrade para VIP para usar o recurso de descriptografia em blocos',
  // Diagrama de criptografia CBC
  'security.diagram.plaintext.block1': 'Bloco de texto simples 1',
  'security.diagram.plaintext.block2': 'Bloco de texto simples 2',
  'security.diagram.ciphertext.block1': 'Bloco cifrado 1',
  'security.diagram.ciphertext.block2': 'Bloco cifrado 2',
  'security.diagram.key': 'Chave de criptografia',
  'security.diagram.aes.encryption': 'Criptografia AES',
  // Smart Chunk Decryption
  'security.features.chunk.title': 'Tecnologia de Descriptografia Inteligente em Blocos',
  'security.features.chunk.what': 'O que é Descriptografia Inteligente em Blocos?',
  'security.features.chunk.description': 'A descriptografia inteligente em blocos é uma tecnologia otimizada para arquivos grandes que divide os arquivos em múltiplos blocos para processamento paralelo, com as seguintes características:',
  'security.features.chunk.feature1.title': 'Divisão Dinâmica',
  'security.features.chunk.feature1.desc': 'Ajusta automaticamente o tamanho dos blocos com base no tamanho do arquivo e memória do sistema',
  'security.features.chunk.feature2.title': 'Processamento Paralelo',
  'security.features.chunk.feature2.desc': 'Múltiplos blocos de dados são descriptografados simultaneamente, aproveitando ao máximo as CPUs multi-core',
  'security.features.chunk.feature3.title': 'Otimização de Memória',
  'security.features.chunk.feature3.desc': 'Controla o uso de memória através de processamento em streaming para evitar overflow',
  'security.features.chunk.feature4.title': 'Suporte à Retomada',
  'security.features.chunk.feature4.desc': 'Suporta continuação após interrupção, melhorando a tolerância a falhas',
  'security.features.chunk.how': 'Como Funciona',
  'security.features.chunk.process': 'O processo de descriptografia inteligente em blocos inclui as seguintes etapas:',
  'security.features.chunk.step1': 'Análise do Arquivo: Calcula o tamanho e quantidade ideal de blocos',
  'security.features.chunk.step2': 'Divisão de Dados: Divide o arquivo criptografado em blocos de tamanho igual',
  'security.features.chunk.step3': 'Descriptografia Paralela: Múltiplos blocos são descriptografados simultaneamente',
  'security.features.chunk.step4': 'Escrita em Stream: Os blocos descriptografados são escritos em sequência',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'Vantagens de Desempenho',
  'security.features.chunk.performance.intro': 'Em comparação com a descriptografia tradicional, a descriptografia inteligente em blocos tem vantagens significativas:',
  'security.features.chunk.performance.point1': 'Uso de memória reduzido em até 90%, apenas 400MB necessários para um arquivo de 4GB',
  'security.features.chunk.performance.point2': 'Velocidade de descriptografia 3-5 vezes mais rápida, aproveitando CPUs multi-core',
  'security.features.chunk.performance.point3': 'Suporta descriptografia de arquivos grandes (>4GB), não limitado pela memória do navegador',
  'security.features.chunk.performance.point4': 'Processo de descriptografia visual com progresso e tempo restante precisos',
  'security.features.chunk.usage': 'Casos de Uso',
  'security.features.chunk.usage.intro': 'A descriptografia inteligente em blocos é particularmente adequada para os seguintes cenários:',
  'security.features.chunk.usage.point1': 'Descriptografia de arquivos grandes (ex. vídeos, backups de banco de dados)',
  'security.features.chunk.usage.point2': 'Operações de descriptografia em dispositivos com memória limitada',
  'security.features.chunk.usage.point3': 'Descriptografia em lote que requer processamento paralelo',
  'security.features.chunk.usage.point4': 'Tarefas de descriptografia que requerem feedback em tempo real',
  'security.features.chunk.diagram': 'Diagrama do Processo de Descriptografia em Blocos',
  'security.features.aes.what': 'O que é AES-256-CBC?',
  'security.features.aes.description': 'AES-256-CBC é uma implementação do Advanced Encryption Standard (Padrão de Criptografia Avançada), onde:',
  'security.features.aes.detail.1': 'Um algoritmo de criptografia simétrica estabelecido pelo Instituto Nacional de Padrões e Tecnologia (NIST) dos EUA em 2001',
  'security.features.aes.detail.2': 'Utiliza chave de 256 bits, fornecendo o mais alto nível de segurança',
  'security.features.aes.detail.3': 'O modo Cipher Block Chaining (CBC) fornece melhor segurança de criptografia',
  'security.features.aes.how': 'Como funciona',
  'security.features.aes.process': 'O processo de criptografia AES-256-CBC inclui os seguintes passos:',
  'security.features.aes.step1': 'Dividir os dados de texto simples em blocos de tamanho fixo (128 bits)',
  'security.features.aes.step2': 'Gerar um vetor de inicialização (IV) aleatório',
  'security.features.aes.step3': 'Realizar operação XOR entre o bloco de texto cifrado anterior e o bloco de texto simples atual usando modo CBC',
  'security.features.aes.step4': 'Usar a chave de 256 bits para realizar a criptografia AES no resultado XOR',
  'security.features.aes.example': 'Exemplo do processo de criptografia:',
  'common.unknown': 'Desconhecido',
  'common.speed': 'Velocidade',
  'common.timeSpent': 'Tempo decorrido',
  'common.remaining': 'Restante',
  // File Info Modal
  'decrypt.fileInfo.modal.title': 'Informações do Arquivo',
  'decrypt.fileInfo.modal.close': 'Fechar',
  'decrypt.fileInfo.name': 'Nome do Arquivo',
  'decrypt.fileInfo.size': 'Tamanho do Arquivo',
  'decrypt.fileInfo.type': 'Tipo do Arquivo',
  'decrypt.fileInfo.lastModified': 'Última Modificação',
  'decrypt.fileInfo.status': 'Estado',
  'decrypt.fileInfo.progress': 'Progresso',
  'decrypt.fileInfo.speed': 'Velocidade',
  'decrypt.fileInfo.timeRemaining': 'Tempo Restante',
  'decrypt.fileInfo.timeSpent': 'Tempo Decorrido',
  'decrypt.fileInfo.error': 'Mensagem de Erro',
  'filelist.action.download': 'Baixar',
  'filelist.action.preview': 'Visualizar',
  'filelist.action.rename': 'Renomear',
  'filelist.modal.rename.title': 'Renomear',
  'filelist.modal.rename.placeholder': 'Digite o novo nome',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'Cancelar',
  'sideMenu.storageInfo.title': 'Espaço de armazenamento',
  'sideMenu.storageInfo.usage': 'Usado {used} / Total {total}',
  'sideMenu.storageStats.title': 'Estatísticas de armazenamento',
  'sideMenu.storageStats.overview': 'Visão geral',
  'sideMenu.storageStats.totalFiles': 'Total de arquivos',
  'sideMenu.storageStats.totalSize': 'Tamanho total',
  'sideMenu.storageStats.fileTypes': 'Distribuição de tipos de arquivo',
  'sideMenu.storageStats.providers': 'Provedores de serviço',
  'common.default': 'Padrão',
  'common.regionCode': 'Código da região',
  'common.nodeType': 'Tipo de nó',
  'common.storageUsed': 'Espaço usado',
  'common.storageAvailable': 'Espaço disponível',
  'common.storageLimit': 'Capacidade total',
  'common.storageUsageDetail': 'Usado {used} / Total {total}',
  'common.defaultNode': 'Nó padrão',
  'common.confirm': 'Confirmar',
  'common.cancel': 'Cancelar',
  'common.latency': 'Latência',
  'common.retry': 'Tentar novamente',
  'cloudDrive.nodeSelect.title': 'Selecionar nó de armazenamento',
  'cloudDrive.nodeSelect.addNode': 'Adicionar nó de armazenamento',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Confirmar exclusão do nó',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Tem certeza de que deseja excluir o nó "{nodeName}"? Esta ação não pode ser desfeita!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Nó excluído com sucesso',
  'cloudDrive.nodeSelect.deleteFailed': 'Falha ao excluir o nó',
  
  // Criação de nó
  'cloudDrive.nodeCreate.title': 'Adicionar nó de armazenamento',
  'cloudDrive.nodeCreate.selectProvider': 'Selecionar provedor de nuvem',
  'cloudDrive.nodeCreate.nodeName': 'Nome do nó',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Deixe em branco para usar o nome padrão',
  'cloudDrive.nodeCreate.nameMaxLength': 'O nome do nó não pode exceder 50 caracteres',
  'cloudDrive.nodeCreate.noProviders': 'Nenhum provedor de nuvem disponível',
  'cloudDrive.nodeCreate.pingLatency': 'Latência {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Testando latência...',
  'cloudDrive.nodeCreate.pingFailed': 'Falha ao testar a latência',
  'cloudDrive.nodeCreate.pingUnavailable': 'Teste de latência indisponível',
  'cloudDrive.nodeCreate.sortByLatency': 'Ordenar por latência',
  'cloudDrive.nodeCreate.selectRegion': 'Selecionar região',
  'cloudDrive.nodeCreate.selectedRegion': 'Região selecionada',
  'cloudDrive.nodeCreate.noRegions': 'Nenhuma região disponível',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Selecione um provedor de nuvem',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Por favor, selecione um provedor de nuvem primeiro',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Por favor, selecione uma região primeiro',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Falha ao carregar a lista de provedores de nuvem',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Falha ao carregar a lista de regiões',
  'cloudDrive.nodeCreate.nodeType': 'Tipo de nó',
  'cloudDrive.nodeCreate.nodeType.standard': 'Armazenamento padrão',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Armazenamento de baixa frequência',
  'cloudDrive.nodeCreate.nodeType.archive': 'Armazenamento de arquivo',
  'cloudDrive.nodeCreate.storageLimit': 'Limite de armazenamento',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Por favor, insira o limite de armazenamento',
  'cloudDrive.nodeCreate.storageLimitMin': 'O limite de armazenamento não pode ser menor que 1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Digite o limite de armazenamento (GB)',
  'cloudDrive.nodeCreate.success': 'Nó de armazenamento criado com sucesso',
  'cloudDrive.nodeCreate.failed': 'Falha ao criar o nó de armazenamento',
  
  // Edição de nó
  'cloudDrive.nodeEdit.title': 'Editar nó',
  'cloudDrive.nodeEdit.name': 'Nome do nó',
  'cloudDrive.nodeEdit.nameRequired': 'Por favor, insira o nome do nó',
  'cloudDrive.nodeEdit.nameMaxLength': 'O nome do nó não pode exceder 50 caracteres'
}; 